<template>
  <div>
    <PageAllow controller="Purchases" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <!-- 发货单信息 -->
        <v-expansion-panels v-model="panelsDetail" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("DeliveryDetail.title") }}
                <v-chip
                  class="ms-4 mt-1"
                  small
                  label
                  :color="purchase.delivery_flg | deliverFlgsColor"
                  :text-color="purchase.delivery_flg | deliverFlgsTextColor"
                >
                  {{ purchase.delivery_flg | deliverFlgsText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="deliveryFlg"
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Save()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Delivery.Fields.save") }}
                  </v-btn>
                  <v-btn
                    v-if="deliveryFlg"
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Delivery()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Delivery.Fields.delivery") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider />

            <v-expansion-panel-content>
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.purchase_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ purchase.purchase_code }}
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ purchase.created | formatTime }}
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.hope_delivery_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.hope_delivery_date | formatDate }}
                    </span>
                  </v-card>
                </v-col>

                <v-col cols="12" md="8">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t("DeliveryDetail.Fields.account_name", [
                          $consts.shopName(),
                        ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase.stock_order != null">
                      {{
                        purchase.stock_order
                          ? purchase.stock_order.shop.shop_name
                          : ""
                      }}
                    </span>
                    <span v-if="purchase.stock_order == null">
                      {{ purchase.stock ? purchase.stock.name : "" }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 收货人 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="settings && settings.show_purchase_address"
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.consignee")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 订单转采购：门店信息中的负责人名字 -->
                    <span>
                      {{
                        purchase.delivery_info
                          ? purchase.delivery_info.receiver_name
                          : ""
                      }}
                      <span v-if="purchase.delivery_info">
                        {{ purchase.delivery_info.receiver_phone }}
                      </span>
                    </span>
                  </v-card>
                </v-col>

                <!-- <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("DeliveryDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="purchase.delivery_info">
                    {{
                      purchase.delivery_info.tel
                        ? purchase.delivery_info.tel
                        : purchase.delivery_info.receiver_phone
                    }}
                  </span>
                </v-card>
              </v-col> -->
                <v-col
                  cols="12"
                  md="12"
                  v-if="settings && settings.show_purchase_address"
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.address")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase && purchase.delivery_info">
                      <AddressText
                        :masterItem="purchase.delivery_info"
                        :detailAddress="
                          purchase.delivery_info.address
                            ? purchase.delivery_info.address
                            : purchase.delivery_info.receiver_address
                            ? '' +
                              purchase.delivery_info.receiver_province +
                              ' ' +
                              purchase.delivery_info.receiver_city +
                              ' ' +
                              purchase.delivery_info.receiver_area +
                              ' ' +
                              purchase.delivery_info.receiver_address
                            : ''
                        "
                      />
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点名称 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="settings && settings.delivery_point"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.delivery_point")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase.delivery_point_province_id">
                      {{
                        $t("DeliveryDetail.Fields.delivery_point_name", [
                          purchase.delivery_point_code,
                          purchase.delivery_point_name,
                        ])
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点负责人 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="settings && settings.delivery_point"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.delivery_point_manager")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.delivery_point_manager }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点联系方式 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="settings && settings.delivery_point"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.delivery_point_tel")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.delivery_point_tel }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点地址 -->
                <v-col
                  cols="12"
                  md="12"
                  v-if="settings && settings.delivery_point"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.delivery_point_address")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.delivery_point_full_address }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.memo")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.memo }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panelsDetail.find((p) => p == 1)
                      ? null
                      : panelsDetail.push(1);
                  "
                >
                  {{ $t("DeliveryDetail.activities.title") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        {{ item.created | formatTime }}
                      </template>
                      <!-- operater_name -->
                      <template v-slot:item.operater_name="{ item }">
                        <span
                          v-if="
                            item.operater && item.operater.type == 4
                              ? true
                              : false
                          "
                        >
                          {{
                            item.operater && item.operater.supplier
                              ? item.operater.supplier.supplier_name
                              : ""
                          }}
                        </span>
                        <span v-else>
                          {{ item.operater ? item.operater.name : "" }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <!-- 对账单明细 -->
      <div class="px-4 pb-4">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-card-title class="ms-n4 py-0">
              {{ $t("DeliveryDetail.detail") }}
              <v-spacer />
            </v-card-title>
          </v-toolbar>
          <v-divider />
            <v-data-table
              id="details_table"
              :headers="headers"
              :items="purchase_details"
              :search="search"
              multi-sort
              disable-pagination
              hide-default-footer
              :show-expand="isShowExpand"
              :expanded.sync="expanded"
              class="pb-2"
            >
              <template v-slot:header.data-table-expand="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n3">
                    <span class="caption secondary--text pt-2">
                      {{
                        $t(
                          "$vuetify.dataFooter.pageText",
                          purchase_details
                            ? [
                                purchase_details.length > 0 ? 1 : 0,
                                purchase_details.length,
                                purchase_details.length,
                              ]
                            : [0, 0, 0]
                        )
                      }}
                    </span>
                    <v-row no-gutters>
                      <v-spacer />
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="search"
                          clearable
                          :label="$t('Search.filter')"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-toolbar>
              </template>
<!--              <template v-slot:footer>-->
<!--                <v-row>-->
<!--                  <v-spacer />-->
<!--                  <v-col cols="12" sm="6" md="3">-->
<!--                    <v-list-item>-->
<!--                      <v-list-item-content>-->
<!--                        <span class="secondary&#45;&#45;text font-weight-bold">-->
<!--                          {{ $t("DeliveryDetail.sum") }}-->
<!--                        </span>-->
<!--                      </v-list-item-content>-->
<!--                      <v-list-item-content class="align-end text-end">-->
<!--                        <span class="accent&#45;&#45;text font-weight-bold">-->
<!--                          {{ $t("Global.money")-->
<!--                          }}{{ purchase.price_fix | formatMoney }}-->
<!--                        </span>-->
<!--                      </v-list-item-content>-->
<!--                    </v-list-item>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--              </template>-->
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity | formatTwoDot }}
              </template>
              <!-- 计数单位数量 -->
              <template v-slot:item.count_unit_num="{ item }">
                <span>
                  {{ item.count_unit_num }} / {{ item.count_unit }}
                </span>
              </template>
              <!-- 发货编辑 -->
              <template v-slot:item.Quantity="{ item }">
                  <v-text-field
                    v-if="deliveryModifyFlg"
                    single-line
                    dense
                    v-model="item.delivery_num"
                    type="number"
                    min="0"
                    @blur="
                      item.delivery_num =
                        $numberFormatter.formatWithDotNoMoreThan(
                          Number(item.delivery_num),
                          2
                        );
                      updateItemTotalPrice(item);
                    "
                    style="max-width: 100px; margin-left: auto"
                    :error-messages="errors"
                  >
                  </v-text-field>
                <span v-else>
                  {{ item.quantity | formatTwoDot }}
                </span>
              </template>
              <!-- price  -->
              <template v-slot:item.price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ $numberFormatter.moneyFormatWithDotNoMoreThan(item.price, 2) }}
                </span>
              </template>
              <template v-slot:item.total="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money")}}{{ (item.total) | formatMoneyFloor }}
                </span>
              </template>

              <template v-slot:item.production_date="{ item }">
                <SearcherDatetime
                  v-if="isProductDate"
                  class="my-n2"
                  v-model="item.production_date"
                  type="date"
                  single-line
                  dense
                  hide-details
                  disabledAfterToday
                />
                <span v-else>
                  {{ item.production_date | formatDate }}
                </span>
              </template>

              <template v-slot:item.expired_date="{ item }">
                <SearcherDatetime
                  v-if="isProductDate"
                  class="my-n2"
                  v-model="item.expired_date"
                  type="date"
                  single-line
                  dense
                  hide-details
                  disabledBeforeToday
                />
                <span v-else>
                  {{ item.expired_date | formatDate }}
                </span>
              </template>
              <!-- 质检报告 -->
              <template v-slot:item.qualify_report_img="{ item }">
                <v-btn
                  :color="(item && item.qualify_report_img  && item.qualify_report_img.length > 0) ? 'orange' : 'primary'"
                  style="color: white"
                  class="my-1"
                  small
                  @click.stop="
                    currentItem = item;
                    qualifyReportDialog = true;
                  "
                >
                  {{ $t("DeliveryDetail.Fields.qualify_report") }}
                </v-btn>
              </template>
              <!-- expend扩展行 -->
              <template v-slot:expanded-item="{ item }">
                <td colspan="6" class="pa-0">
                  <div style="height: 50px"></div>
                  <v-divider />
                  <div style="height: 50px"></div>
                </td>
                <td class="pa-0">
                  <div style="height: 50px" class="pa-3">
                    <v-text-field
                      single-line
                      dense
                      hide-details
                      v-model="item.delivery_num_2"
                      type="number"
                      min="0"
                      @blur="item.delivery_num_2 = $numberFormatter.formatWithDotNoMoreThan(Number(item.delivery_num_2),2)"
                      style="max-width: 100px; margin-left: auto"
                      v-if="deliveryModifyFlg"
                    >
                    </v-text-field>
                  </div>
                  <v-divider />
                  <div style="height: 50px" class="pa-3">
                    <v-text-field
                      single-line
                      dense
                      hide-details
                      v-model="item.delivery_num_3"
                      type="number"
                      min="0"
                      @blur="item.delivery_num_3 = $numberFormatter.formatWithDotNoMoreThan(Number(item.delivery_num_3),2)"
                      style="max-width: 100px; margin-left: auto"
                      v-if="deliveryModifyFlg"
                    >
                    </v-text-field>
                  </div>
                </td>
                <td class="pa-0">
                  <div style="height: 50px" class="pa-3">
                    <div style="line-height: 50px;text-align: center">
                     <span v-if="item.negotiate_price_flg == 1">
                       {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
                     </span>
                      <span v-else>
                      {{ $t("Global.money")}}{{ (item.delivery_num_2 * item.price) | formatMoney }}
                    </span>
                    </div>
                  </div>
                  <v-divider />
                  <div style="height: 50px" class="pa-3">
                    <div style="line-height: 50px;text-align: center">
                    <span v-if="item.negotiate_price_flg == 1">
                      {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
                    </span>
                      <span v-else>
                      {{ $t("Global.money")}}{{ (item.delivery_num_3 * item.price) | formatMoney }}
                    </span>
                    </div>
                  </div>
                </td>
                <td class="pa-0" v-if="settings && settings.product_date_setting == 1">
                  <div style="height: 50px" class="pa-4">
                    <SearcherDatetime
                      v-if="isProductDate"
                      class="my-n2"
                      v-model="item.production_date_2"
                      type="date"
                      single-line
                      dense
                      hide-details
                      disabledAfterToday
                    />
                    <span v-else>
                    {{ item.production_date_2 | formatDate }}
                  </span>
                  </div>
                  <v-divider />
                  <div style="height: 50px" class="pa-4">
                    <SearcherDatetime
                      v-if="isProductDate"
                      class="my-n2"
                      v-model="item.production_date_3"
                      type="date"
                      single-line
                      dense
                      hide-details
                      disabledAfterToday
                    />
                    <span v-else>
                    {{ item.production_date_3 | formatDate }}
                  </span>
                  </div>
                </td>
                <td class="pa-0" v-if="settings && settings.product_date_setting == 1">
                  <div style="height: 50px" class="pa-4">
                    <SearcherDatetime
                      v-if="isProductDate"
                      class="my-n2"
                      v-model="item.expired_date_2"
                      type="date"
                      single-line
                      dense
                      hide-details
                      disabledBeforeToday
                    />
                    <span v-else>
                    {{ item.expired_date_2 | formatDate }}
                  </span>
                  </div>
                  <v-divider />
                  <div style="height: 50px" class="pa-4">
                    <SearcherDatetime
                      v-if="isProductDate"
                      class="my-n2"
                      v-model="item.expired_date_3"
                      type="date"
                      single-line
                      dense
                      hide-details
                      disabledBeforeToday
                    />
                    <span v-else>
                    {{ item.expired_date_3 | formatDate }}
                  </span>
                  </div>
                </td>
                <td class="pa-0">
                  <div style="height: 50px">

                  </div>
                  <v-divider />
                  <div style="height: 50px">

                  </div>
                </td>
                <!-- 质检报告 -->
                <td class="pa-0 text-center" v-if="settings && settings.qualify_report_enable == 1">
                  <div style="height: 50px;line-height: 50px">
                    <v-btn
                      :color="(item && item.qualify_report_img_2  && item.qualify_report_img_2.length > 0) ? 'orange' : 'primary'"
                      style="color: white"
                      class="my-1"
                      small
                      @click.stop="
                        currentItem = item;
                        qualifyReportDialog_2 = true;
                      "
                    >
                      {{ $t("DeliveryDetail.Fields.qualify_report") }}
                    </v-btn>
                  </div>
                  <v-divider />
                  <div style="height: 50px;line-height: 50px">
                    <v-btn
                      :color="(item && item.qualify_report_img_3  && item.qualify_report_img_3.length > 0) ? 'orange' : 'primary'"
                      style="color: white"
                      class="my-1"
                      small
                      @click.stop="
                        currentItem = item;
                        qualifyReportDialog_3 = true;
                      "
                    >
                      {{ $t("DeliveryDetail.Fields.qualify_report") }}
                    </v-btn>
                  </div>
                </td>
                <td class="pa-0">
                  <div style="height: 50px">

                  </div>
                  <v-divider />
                  <div style="height: 50px">

                  </div>
                </td>
              </template>
            </v-data-table>
        </v-card>
      </div>
    </v-sheet>
    <DialogPostImages
      v-model="qualifyReportDialog"
      @addComfirm="currentItem.qualify_report_img = $event"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img &&
        currentItem.qualify_report_img.length > 0
          ? currentItem.qualify_report_img
          : []
      "
    />
    <DialogPostImages
      v-model="qualifyReportDialog_2"
      @addComfirm="currentItem.qualify_report_img_2 = $event"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img_2 &&
        currentItem.qualify_report_img_2.length > 0
          ? currentItem.qualify_report_img_2
          : []
      "
    />
    <DialogPostImages
      v-model="qualifyReportDialog_3"
      @addComfirm="currentItem.qualify_report_img_3 = $event"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img_3 &&
        currentItem.qualify_report_img_3.length > 0
          ? currentItem.qualify_report_img_3
          : []
      "
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddressText from "@/components/plugins/AddressText";
import Delivery from "@/api/delivery";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Orders from "@/api/orders";
import DialogPostImages from "./plugins/DialogPostImages";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    AddressText,
    SearcherDatetime,
    DialogPostImages,
    // NumberInput
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    deliveryModifyFlg() {
      // delivery_modify_flg == 1 可修改发货数量
      if (
        this.accountUser &&
        this.accountUser.supplier.delivery_modify_flg == 1
      ) {
        return true;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    isProductDate() {
      // product_date_setting == 1  可编辑生产日期
      if (this.settings && this.settings.product_date_setting == 1) {
        return true;
      }
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.$route.path.startsWith("/purchases/edit")
            ? i18n.t("Nav.purchases")
            : i18n.t("Nav.delivery"),
          disabled: false,
          href: this.$route.path.startsWith("/purchases/edit")
            ? "/purchases"
            : "/delivery",
        },
        {
          text: this.$route.path.startsWith("/purchases/edit")
            ? i18n.t("Nav.purchasesList")
            : i18n.t("Nav.deliveryDetail"),
          disabled: false,
          href: this.$route.path.startsWith("/purchases/edit")
            ? "/purchases"
            : "/delivery",
        },
        {
          text: i18n.t("DeliveryDetail.title"),
          disabled: true,
          href: "/delivery",
        },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("DeliveryDetail.Fields.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.price"),
          align: "end",
          sortable: false,
          value: "price",
        },
        // 申请量
        {
          text: i18n.t("DeliveryDetail.Fields.delivery_volume"),
          align: "end",
          sortable: false,
          value: "quantity",
        },
        // 发货量
        {
          text: i18n.t("DeliveryDetail.Fields.delivery_num"),
          align: "center",
          sortable: false,
          value: "Quantity",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.default_unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        // 计数单位数量 (启用计数单位且订单转采购时显示)
        ...(this.settings && this.settings.count_unit && this.purchase && this.purchase.order_code ? [{
          text: i18n.t("DeliveryDetail.Fields.count_unit_num"),
          align: "end",
          sortable: false,
          value: "count_unit_num",
        }] : []),
        {
          text: i18n.t("DeliveryDetail.Fields.sum"),
          align: "center",
          sortable: false,
          value: "total",
        },
      ];
      if (this.settings && this.settings.product_date_setting == 1) {
        headers.push(
          {
            text: i18n.t("DeliveryDetail.Fields.production_date"),
            align: "start",
            sortable: false,
            value: "production_date",
          },
          {
            text: i18n.t("DeliveryDetail.Fields.expired_date"),
            align: "start",
            sortable: false,
            value: "expired_date",
          }
        );
      }
      headers.push({
        text: i18n.t("DeliveryDetail.Fields.memo"),
        align: "start",
        sortable: false,
        value: "memo",
      });
      if (this.settings && this.settings.qualify_report_enable == 1) {
        headers.push({
          text: i18n.t("DeliveryDetail.Fields.qualify_report"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "qualify_report_img",
        });
      }

      if (this.isShowExpand) {
        headers.push({
          text: "",
          align: "start",
          sortable: false,
          value: "data-table-expand",
        });
      }

      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("DeliveryDetail.activities.Fields.time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("DeliveryDetail.activities.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("DeliveryDetail.activities.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    isShowExpand() {
      return  !!(this.accountUser &&
          this.accountUser.supplier &&
          this.accountUser.supplier.delivery_modify_flg == 1 &&
          this.settings &&
          this.settings.product_date_setting &&
          this.settings.purchase_subtotal != 1)
    },
    ...mapState(["accountInfo", "settings", "accountUser"]),
  },
  data: () => ({
    expanded: [],
    panels: [0],
    panelsDetail: [0],
    Detail: [0],
    tab: null,
    search: "",
    purchase: {},
    purchase_details: [],
    activities_details: [],
    deliveryFlg: null,
    error: false,
    order: {},
    qualifyReportDialog: false,
    qualifyReportDialog_2: false,
    qualifyReportDialog_3: false,
    currentItem: null,
  }),

  mounted() {
    this.getDeliveryFromAPI();
  },

  methods: {
    getDeliveryFromAPI() {
      Delivery.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase = response.data.purchase;
            this.purchase_details = response.data.purchase.purchase_details;
            this.activities_details = response.data.order_activities;
            this.deliveryFlg = response.data.purchase.actions.delivery;
          }
          this.purchase_details = this.purchase_details.map((e) => {
            e.delivery_num = e.temporary_num !== null
              ? Number(e.temporary_num)
              : Number(e.quantity);
            return e;
          });
          if (this.purchase.order_id) {
            this.getOrderFromAPI(this.purchase.order_id);
          }
        }.bind(this)
      );
    },
    getOrderFromAPI(order_id) {
      Orders.fetchOne(order_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order = response.data.order;
          }
        }.bind(this)
      );
    },
    Save() {
      let data = [];
      this.purchase_details.map((e) => {
        if (this.settings && this.settings.product_date_setting == 1) {
          if (
            this.accountUser &&
            this.accountUser.supplier &&
            this.accountUser.supplier.delivery_modify_flg == 1
          ) {
            if (
              (e.delivery_num && e.delivery_num != "0") ||
              (e.delivery_num == 0 && e.delivery_num !== "")
            ) {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num,
                production_date: e.production_date,
                expired_date: e.expired_date,
                qualify_report_img:
                  e.qualify_report_img && e.qualify_report_img.length
                    ? e.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_2 && e.delivery_num_2 != "0") {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num_2,
                production_date: e.production_date_2,
                expired_date: e.expired_date_2,
                qualify_report_img:
                  e.qualify_report_img_2 && e.qualify_report_img_2.length
                    ? e.qualify_report_img_2.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_3 && e.delivery_num_3 != "0") {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num_3,
                production_date: e.production_date_3,
                expired_date: e.expired_date_3,
                qualify_report_img:
                  e.qualify_report_img_3 && e.qualify_report_img_3.length
                    ? e.qualify_report_img_3.map((img) => img.img_name)
                    : [],
              });
            }
          } else {
            data.push({
              id: e.id,
              temporary_num: e.quantity,
              production_date: e.production_date,
              expired_date: e.expired_date,
              qualify_report_img:
                e.qualify_report_img && e.qualify_report_img.length
                  ? e.qualify_report_img.map((img) => img.img_name)
                  : [],
            });
          }
        } else {
          if (
            this.accountUser &&
            this.accountUser.supplier &&
            this.accountUser.supplier.delivery_modify_flg == 1
          ) {
            if (
              (e.delivery_num && e.delivery_num != "0") ||
              (e.delivery_num == 0 && e.delivery_num !== "")
            ) {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num,
                qualify_report_img:
                  e.qualify_report_img && e.qualify_report_img.length
                    ? e.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_2 && e.delivery_num_2 != "0") {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num_2,
                qualify_report_img:
                  e.qualify_report_img_2 && e.qualify_report_img_2.length
                    ? e.qualify_report_img_2.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_3 && e.delivery_num_3 != "0") {
              data.push({
                id: e.id,
                temporary_num: e.delivery_num_3,
                qualify_report_img:
                  e.qualify_report_img_3 && e.qualify_report_img_3.length
                    ? e.qualify_report_img_3.map((img) => img.img_name)
                    : [],
              });
            }
          } else {
            data.push({
              id: e.id,
              temporary_num: e.quantity,
              qualify_report_img:
                e.qualify_report_img && e.qualify_report_img.length
                  ? e.qualify_report_img.map((img) => img.img_name)
                  : [],
            });
          }
        }
      });
      if (data.length) {
        this.$store.dispatch("fullscreenLoading");
        Delivery.supplierEdit(this.$route.params.id, {
          id: this.$route.params.id,
          purchase_details: data,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (this.$route.path.startsWith("/purchases/edit")) {
                this.$router.replace("/purchases");
              } else {
                this.$router.replace("/delivery");
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
    Delivery() {
      let data = [];
      this.purchase_details.map((e) => {
        if (this.settings && this.settings.product_date_setting == 1) {
          if (
            this.accountUser &&
            this.accountUser.supplier &&
            this.accountUser.supplier.delivery_modify_flg == 1
          ) {
            if (e.delivery_num && e.delivery_num != "0") {
                data.push({
                  id: e.id,
                  delivery_num: e.delivery_num,
                  production_date: e.production_date,
                  expired_date: e.expired_date,
                  qualify_report_img:
                    e.qualify_report_img && e.qualify_report_img.length
                      ? e.qualify_report_img.map((img) => img.img_name)
                      : [],
                }); 
            } else if (e.delivery_num == 0 && e.delivery_num !== "") {
              data.push({
                id: e.id,
                delivery_num: e.delivery_num,
                production_date: e.production_date,
                expired_date: e.expired_date,
                qualify_report_img:
                  e.qualify_report_img && e.qualify_report_img.length
                    ? e.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_2 && e.delivery_num_2 != "0") {
                data.push({
                  id: e.id,
                  delivery_num: e.delivery_num_2,
                  production_date: e.production_date_2,
                  expired_date: e.expired_date_2,
                  qualify_report_img:
                    e.qualify_report_img_2 && e.qualify_report_img_2.length
                      ? e.qualify_report_img_2.map((img) => img.img_name)
                      : [],
                });
            }
            if (e.delivery_num_3 && e.delivery_num_3 != "0") {
                data.push({
                  id: e.id,
                  delivery_num: e.delivery_num_3,
                  production_date: e.production_date_3,
                  expired_date: e.expired_date_3,
                  qualify_report_img:
                    e.qualify_report_img_3 && e.qualify_report_img_3.length
                      ? e.qualify_report_img_3.map((img) => img.img_name)
                      : [],
                });
            }
          } else {
            data.push({
              id: e.id,
              delivery_num: e.quantity,
              production_date: e.production_date,
              expired_date: e.expired_date,
              qualify_report_img:
                e.qualify_report_img && e.qualify_report_img.length
                  ? e.qualify_report_img.map((img) => img.img_name)
                  : [],
            });
          }
        } else {
          if (
            this.accountUser &&
            this.accountUser.supplier &&
            this.accountUser.supplier.delivery_modify_flg == 1
          ) {
            if (e.delivery_num && e.delivery_num != "0") {
              data.push({
                id: e.id,
                delivery_num: e.delivery_num,
                qualify_report_img:
                  e.qualify_report_img && e.qualify_report_img.length
                    ? e.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            } else if (e.delivery_num == 0 && e.delivery_num !== "") {
              data.push({
                id: e.id,
                delivery_num: e.delivery_num,
                qualify_report_img:
                  e.qualify_report_img && e.qualify_report_img.length
                    ? e.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_2 && e.delivery_num_2 != "0") {
              data.push({
                id: e.id,
                delivery_num: e.delivery_num_2,
                qualify_report_img:
                  e.qualify_report_img_2 && e.qualify_report_img_2.length
                    ? e.qualify_report_img_2.map((img) => img.img_name)
                    : [],
              });
            }
            if (e.delivery_num_3 && e.delivery_num_3 != "0") {
              data.push({
                id: e.id,
                delivery_num: e.delivery_num_3,
                qualify_report_img:
                  e.qualify_report_img_3 && e.qualify_report_img_3.length
                    ? e.qualify_report_img_3.map((img) => img.img_name)
                    : [],
              });
            }
          } else {
            data.push({
              id: e.id,
              delivery_num: e.quantity,
              qualify_report_img:
                e.qualify_report_img && e.qualify_report_img.length
                  ? e.qualify_report_img.map((img) => img.img_name)
                  : [],
            });
          }
        }
      });
      if (data.length) {
        this.$store.dispatch("fullscreenLoading");
        Delivery.delivery({
          id: this.$route.params.id,
          delivery_details: data,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (this.$route.path.startsWith("/purchases/edit")) {
                this.$router.replace(
                  "/purchases/detail/" + this.$route.params.id
                );
              } else {
                this.$router.replace("/delivery/" + this.$route.params.id);
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
    updateItemTotalPrice(material) {
      const isPurchaseSubtotalEnabled = this.settings?.purchase_subtotal == 1;
      const isFromOrder = !!this.purchase?.stock_order_code;
      // 开启采购小计且非订单转采购：根据小计反推单价
      if (isPurchaseSubtotalEnabled && !isFromOrder) {
        if (material.delivery_num != 0) {
          material.price = this.$numberFormatter.formatMoney(parseFloat((material.total / material.delivery_num).toFixed(4)), 2);
        } else {
          material.price = 0;
        }
      } else {
        if (material.delivery_num != 0) {
          material.total = this.$numberFormatter.formatMoneyFloor(parseFloat((material.price * material.delivery_num).toFixed(4)), 2);
        } else {
          material.total = 0;
        }
      }
    },
  },
  watch: {
    purchase_details: {
      deep: true,
      handler() {
        var dayjs = require("dayjs");
        this.purchase_details.forEach((detail) => {
          detail.priceFix = detail.price * detail.delivery_num;
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date &&
            !detail.expired_date
          ) {
            detail.expired_date = dayjs(detail.production_date)
              .add(Number(detail.bestbefore) - 1, "day")
              .format("YYYY-MM-DD");
          }
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date_2 &&
            !detail.expired_date_2
          ) {
            detail.expired_date_2 = dayjs(detail.production_date_2)
              .add(Number(detail.bestbefore) - 1, "day")
              .format("YYYY-MM-DD");
          }
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date_3 &&
            !detail.expired_date_3
          ) {
            detail.expired_date_3 = dayjs(detail.production_date_3)
              .add(Number(detail.bestbefore) - 1, "day")
              .format("YYYY-MM-DD");
          }
          // //计算小计金额
          // if (this.settings && this.settings.purchase_subtotal == 1 && this.purchase && this.purchase.origin_flg != 102) {
          //   if (detail.delivery_num && detail.delivery_num != 0) {
          //     detail.price = this.$numberFormatter.formatMoney(Number(detail.total) / Number(detail.delivery_num));
          //   } else {
          //     detail.price = 0;
          //   }
          // } else {
          //   detail.total = this.$numberFormatter.formatMoneyFloor((Number(detail.delivery_num) * Number(detail.price)).toFixed(5));
          // }
        });
        this.purchase.price_fix = 0;
        for (var i = 0; i < this.purchase_details.length; i++) {
          this.purchase.price_fix += this.purchase_details[i].priceFix;
          // this.purchase.price_fix += Number(this.purchase_details[i].total);
        }
      },
    },
    currentItem: {
      deep: true,
      handler() {
        this.purchase_details.forEach((detail) => {
          if (detail.id == this.currentItem.id) {
            this.$set(
              detail,
              "qualify_report_img",
              this.currentItem.qualify_report_img
                ? this.currentItem.qualify_report_img
                : []
            );
            this.$set(
              detail,
              "qualify_report_img_2",
              this.currentItem.qualify_report_img_2
                ? this.currentItem.qualify_report_img_2
                : []
            );
            this.$set(
              detail,
              "qualify_report_img_3",
              this.currentItem.qualify_report_img_3
                ? this.currentItem.qualify_report_img_3
                : []
            );
          }
        });
      },
    },
  },
};
</script>

<style>
</style>